import { render, staticRenderFns } from "./AboutPage2.vue?vue&type=template&id=0950c2d7&scoped=true"
import script from "./AboutPage2.vue?vue&type=script&lang=js"
export * from "./AboutPage2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0950c2d7",
  null
  
)

export default component.exports